module.exports = __webpack_public_path__ + "static/img/limit_white_02.37d438bf.svg";